import React from 'react';
import styled from 'styled-components';
import shadowPlusLogo from '../atoms/data/standard-color.svg';
import icon_notice from '../../components/atoms/data/icon_notice.svg';
import PropTypes from 'prop-types';

const HeaderHome = (props) => {

    let noticeStyle = { display: "none" };
    if(!props.noticeFlg){
        noticeStyle = { color: "red" };
    }
    return(
        <Body>
            <Title>
                <img alt="shdplus-logo" src={shadowPlusLogo} style={{width: "150px"}} />
            </Title>
            <NoticeIcon onClick={props.onClickNotice}> 
                <MarkA>{<i className="fas fa-circle fa-xs" style={noticeStyle} />}</MarkA>
                <img alt="icon_notice" src={icon_notice} width="40px" />
            </NoticeIcon>            
        </Body>
    );
}

export { HeaderHome };

HeaderHome.propTypes = {
    noticeFlg: PropTypes.bool.isRequired,
    onClickNotice: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 2;
`;
const Title = styled.div`
    position: relative;
    width: 100%;
    margin:auto;
    font-size: 24px;
    text-align: center;
`;
const NoticeIcon = styled.div`
    position: absolute;
    width: 10%;
    text-align: right;
    margin:auto;
    line-height:0px;
    right: 20px;
`;
const MarkA = styled.div`
    position: absolute;
    font-size: 18px;
    color:red;
    top: -5px;
    right: 0px;
`;